import React from 'react';
import { useLocation } from 'react-router-dom';

import { setPreviousPath, setState, getRedirectUri } from './storage';

export var Login = function Login() {
    var location = useLocation();

    var state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    var callbackUrl = getRedirectUri();
    setPreviousPath(getPreviousLocation(location));
    setState(state);
    var loginUrl = getLoginHost() + '/oauth2/authorize?redirect_uri=' + callbackUrl + '&state=' + state;
    window.location = loginUrl;
    return null;
};

var getLoginHost = function getLoginHost() {
    if (process.env.REACT_APP_LOGIN_HOST) {
        return process.env.REACT_APP_LOGIN_HOST;
    } else {
        return 'https://beta-login.ekultur.org';
    }
};

var getPreviousLocation = function getPreviousLocation(location) {
    if (location.state && location.state.previousPathname) {
        return filterLocationBlacklist(location.state.previousPathname);
    } else {
        return '/';
    }
};

var filterLocationBlacklist = function filterLocationBlacklist(prevLocation) {
    switch (prevLocation) {
        case '/login':
            return '/';
        case '/logout':
            return '/';
        case '/oauth2/callback':
            return '/';
        default:
            return prevLocation;
    }
};